import gql from 'graphql-tag'

export default gql`
mutation rescheduleAppointment(
  $id: ID!
  $token: String
  $staffId: ID
  $date: DateTime!
  $duration: Int!
  $clientTimezone: String
  $location: String
  $occurrenceDate: DateTime
  $rescheduleFutureOccurrences: Boolean
) {
  rescheduleAppointment(
    id: $id
    token: $token
    staffId: $staffId
    date: $date
    duration: $duration
    clientTimezone: $clientTimezone
    location: $location
    occurrenceDate: $occurrenceDate
    rescheduleFutureOccurrences: $rescheduleFutureOccurrences
  ) {
    id
    date
    price
    currency
    duration
    business
    staff
    customer
    service
    answers
    clientTimezone
    hangoutLink
    locationValue
    locationType
    rrule
    addToGoogleUrl
    addToOutlookUrl
    icsFileContent
    approved
  }
}
`
